app.controller("EmployeeSharedDocumentsController", [
    "$scope", "$stateParams", "DocumentsService", "$uibModal", "$state", "usSpinnerService",
    function ($scope, $stateParams, DocumentsService, $uibModal, $state, usSpinnerService) {
        $scope.documents = [];
        $scope.totalItems = 0;
        $scope.itemsPerPage = $stateParams.limit || 10;
        $scope.format = "dd-MM-yyyy";
        $scope.query = $stateParams.query || null;

        loadPage($stateParams.page).then(function () {
            $scope.currentPage = $stateParams.page;
        });

        function loadPage(page) {
            usSpinnerService.spin("root");
            return DocumentsService.getSharedDocuments({
                page: page,
                limit: $scope.itemsPerPage,
                query: $scope.query
            }).then(function (res) {
                $scope.documents = res.docs;
                $scope.totalItems = res.total;
                $scope.itemsPerPage = res.limit;
                usSpinnerService.stop("root");
            });
        }

        $scope.changePage = function () {
            $state.go(".", { page: $scope.currentPage });
        };

        $scope.open = function (doc, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "ViewDocumentWindowController",
                templateUrl: _pb + 'employee/documents/view-document-window.html',
                size: "lg",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            document: doc.document,
                            shared: doc,
                            action: 'shared'
                        };
                    }
                }
            }).closed.then(function () {
                loadPage($stateParams.page).then(function () {
                    $scope.currentPage = $stateParams.page;
                });
            });
        };

        $scope.showComment = function (comment, $event) {
            if ($event) {
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "CommentWindowController",
                templateUrl: _pb + 'employee/documents/comment-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            comment: comment,
                            action: 'view',
                            header: 'კანცელარიის'
                        };
                    }
                }
            })
        };

        $scope.download = function (url, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            window.open(url);
        };

        $scope.download = function (url, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            window.open(url);
        };
    }
]);
